import React, { Component } from "react"
import { connect } from "react-redux"

import {BrowserRouter as Router, Switch, Route, Redirect} from "react-router-dom"
import Home from "./Home"
import About from "./About"
import Users from "./Users"
import Hedear from "./Hedear"
import Login from "./Login"
import ChangePass from "./ChangePass"
import RequestDetail from "./RequestDetail"
import ArchiveOrdersPay from "./ArchiveOrdersPay"
import ArchiveOrdersMali from "./ArchiveOrdersMali"
import ArchiveOrdersOffine from "./ArchiveOrdersOffine"
import ArchiveOrdersNotPay from "./ArchiveOrdersNotPay"
import ChangeSendRequest from "./ChangeSendRequest"
import ChangeRequestFinancialApproval from "./ChangeRequestFinancialApproval"
import ChangeReportDoc from "./ChangeReportDoc"
import ChangeReportPay from "./ChangeReportPay"
import ChangeAddRequest from "./ChangeAddRequest"
import ChangeUserTherapy from "./ChangeUserTherapy"
import ChangeReportInstalment from "./ChangeReportInstalment"
import ChangeRequestFinancialPay from "./ChangeRequestFinancialPay"
import ChangeRefundUserFinancial from "./ChangeRefundUserFinancial"
import ChangeReportReferral from "./ChangeReportReferral"
import ChangeReportFinancial from "./ChangeReportFinancial"
import ChangeEmployee from "./ChangeEmployee"
import ChangeFieldCompany from "./ChangeFieldCompany"
import ChangePackageinsurance from "./ChangePackageinsurance"
import ChangeManagdiscount from "./ChangeManagdiscount"
import ChangeInstalment from "./ChangeInstalment"
import ChangeOrganTherapyContrat from "./ChangeOrganTherapyContrat"
import ChangeOrganContrat from "./ChangeOrganContrat"
import ChangeDiscountcode from "./ChangeDiscountcode"
import ChangeEvaluatorCo from "./ChangeEvaluatorCo"
import ChangeCompany from "./ChangeCompany"
import ChangeCar from "./ChangeCar"
import ChangeThirdparty from "./ChangeThirdparty"
import ChangeBodyCar from "./ChangeBodyCar"
import ChangeTherapy from "./ChangeTherapy"

import ChangeAccident from "./ChangeAccident"

import ChangeSmsReceiver from "./ChangeSmsReceiver"
import MarketersPanel from "./MarketersPanel"
import IssuanceMarketersPanel from "./IssuanceMarketersPanel"

import ChangeElevator from "./ChangeElevator"
import ChangeTravel from "./ChangeTravel"
import ChangeCorona from "./ChangeCorona"
import ChangeMarketer from "./ChangeMarketer"
import ChangePartnerRequest from "./ChangePartnerRequestPage"
import GetLocation from "./GetLocation"
import ChangeResponsdoctors from "./ChangeResponsdoctors"
import ChangeFireHome from "./ChangeFireHome"
import ChangeFireWarehouse from "./ChangeFireWarehouse"
import ChangePet from "./ChangePet"
import ChangeInvestment from "./ChangeInvestment"
import ChangeFireIndustrial from "./ChangeFireIndustrial"
import ChangeFireHouse from "./ChangeFireHouse"
import ChangeFireProperty from "./ChangeFireProperty"
import ChangeFireEmployeehouse from "./ChangeFireEmployeehouse"
import ChangeFireOwnership from "./ChangeFireOwnership"
import ChangeFireNonIndustrial from "./ChangeFireNonIndustrial"
import ChangeResbuildmng from "./ChangeResbuildmng"
import ChangeBuildingQuality from "./ChangeBuildingQuality"
import ChangeRequiredimgdmg from "./ChangeRequiredimgdmg"
import ChangeRequestQuestion from "./ChangeRequestQuestion"
import ChangeSmsManage from "./ChangeSmsManage"
import ChangeRequiredimgins from "./ChangeRequiredimgins"
import ChangeParamstep from "./ChangeParamstep"
import ChangeFieldDamagefile from "./ChangeFieldDamagefile"
import ChangeFieldInsurance from "./ChangeFieldInsurance"
import ChangeFieldinsuranceGroup from "./ChangeFieldinsuranceGroup"
import ChangePermision from "./ChangePermision"
import ChangeExpert from "./ChangeExpert"
import ChangeAgent from "./ChangeAgent"
import ChangeOrgan from "./ChangeOrgan"
import ChangeKindsendrequest from "./ChangeKindsendrequest"
import ChangeKindsenddamagefile from "./ChangeKindsenddamagefile"
import EditProfile from "./EditProfile"
import ForgetPass from "./ForgetPass"
import NoMatch from "./NoMatch"
import { Cookies } from "react-cookie"
import Loader from "react-loader-spinner"
import { Grid } from "@material-ui/core"

import Box from "@material-ui/core/Box"

import * as constants from "../constants"
import ChangePaymentGateway from "./ChangePaymentGateway";
import MySweetSMSHandler from "./mySweetSMSHandler";
import MySweetContentManager from "./mySweetContentManager";
import MySweetSmsHandlerMainPage from "./MySweetSmsHandlerMainPage";
import ChangeResBossToEmployee from "./ChangeResBossToEmployee";
import ChangeResponseSupervisingEngineer from "./ChangeResponsSupervisingEngineer";
import ChangeResABN from "./ChangeResABN";
import ChangeSmsReceiverEngineeringSystem from "./ChangeSmsReceiverEngineeringSystem";

class AppContainer extends Component {
      cookies = new Cookies()
      opacity = 1

      constructor() {
            super()
            this.state = {}
      }

      componentDidMount() {
            const token = this.cookies.get("employee_token_str");
            const employee_id = this.cookies.get("employee_id");

            if (token && employee_id) {
                  const fd = new FormData();
                  fd.append("command", "getemployee");
                  fd.append("employee_id", employee_id);

                  const xhttp = new XMLHttpRequest();
                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`);
                  xhttp.setRequestHeader("Authorization", token);

                  xhttp.onreadystatechange = () => {
                        if (xhttp.readyState === 4 && xhttp.status === 200) {
                              const res = JSON.parse(xhttp.responseText);

                              if (res.result === "ok") {
                                    this.props.dispatch({
                                          type: "SETPROPEMPLOYEE",
                                          state: res.data,
                                    });
                              }
                        }
                  };

                  xhttp.send(fd);
            }
      }



      componentDidUpdate() {}

      render() {
            const id = this.cookies.get("employee_id")

            const { waitState } = this.props
            if (waitState) {
                  this.opacity = 0.5
            } else {
                  this.opacity = 1
            }
            const userData = this.props.employeeProperty; // یا هر داده‌ای که داری
            const role_name = this.cookies.get("role_name")
            let roles = [];
            try {
                  const rolesCookie = this.cookies.get("roles") || "[]";
                  // اگر رشته است، JSON.parse می‌کنیم
                  roles = typeof rolesCookie === "string" ? JSON.parse(rolesCookie) : rolesCookie;

                  // اگر فقط یک رشته ساده بود، تبدیل به آرایه می‌کنیم
                  if (!Array.isArray(roles)) {
                        roles = [roles];
                  }
            } catch (e) {
                  roles = [];
            }

            const routesConfig = {
                  "واحد تمدیدی": [
                        { path: "/MarketersPanel", component: MarketersPanel },
                  ],
                  "واحد صدور": [
                        { path: "/IssuanceMarketersPanel", component: IssuanceMarketersPanel },
                  ],
                  "واحد اتومبیل": [
                        { path: "/changeSmsReceiver", component: ChangeSmsReceiver },
                  ],
                  "واحد مالی": [
                        { path: "/changerequestfinancialapproval", component: ChangeRequestFinancialApproval },
                        { path: "/changerequestfinancialpay", component: ChangeRequestFinancialPay },
                        // { path: "/changereportdoc", component: ChangeReportDoc },
                        { path: "/changereportpay", component: ChangeReportPay },
                        { path: "/changeReportfinancial", component: ChangeReportFinancial },
                        { path: "/changerefunduserfinancial", component: ChangeRefundUserFinancial },

                      // بازاریاب
                        { path: "/changemarketer", component: ChangeMarketer },

                        { path: "/archiveordermali", component: ArchiveOrdersMali },
                        { path: "/requestdetail", component: RequestDetail },
                  ],
                  "پیش فرض": [
                        { path: "/IssuanceMarketersPanel", component: IssuanceMarketersPanel },
                        { path: "/MarketersPanel", component: MarketersPanel },
                        { path: "/about", component: About },
                        { path: "/paymentGateway", component: ChangePaymentGateway },
                        { path: "/contentManager", component: MySweetContentManager },
                        { path: "/changepass", component: ChangePass },
                        { path: "/mySweetSMHandler", component: MySweetSmsHandlerMainPage },
                        { path: "/requestdetail", component: RequestDetail },
                        { path: "/archiveorderpay", component: ArchiveOrdersPay },
                        { path: "/archiveordermali", component: ArchiveOrdersMali },
                        { path: "/archiveordersnotpay", component: ArchiveOrdersNotPay },
                        { path: "/archiveordersoffine", component: ArchiveOrdersOffine },
                        { path: "/changesendrequest", component: ChangeSendRequest },
                        { path: "/changerequestfinancialapproval", component: ChangeRequestFinancialApproval },
                        { path: "/changerequestfinancialpay", component: ChangeRequestFinancialPay },
                        { path: "/changereportpay", component: ChangeReportPay },
                        { path: "/changereportdoc", component: ChangeReportDoc },
                        { path: "/changeusertherapy", component: ChangeUserTherapy },
                        { path: "/changeaddrequest", component: ChangeAddRequest },
                        { path: "/changereportinstalment", component: ChangeReportInstalment },
                        { path: "/changerefunduserfinancial", component: ChangeRefundUserFinancial },
                        { path: "/ChangeReportReferral", component: ChangeReportReferral },
                        { path: "/changeReportfinancial", component: ChangeReportFinancial },
                        { path: "/changeemployee", component: ChangeEmployee },
                        { path: "/changefieldcompany", component: ChangeFieldCompany },
                        { path: "/changepackageinsurance", component: ChangePackageinsurance },
                        { path: "/changemanagdiscount", component: ChangeManagdiscount },
                        { path: "/changeinstalment", component: ChangeInstalment },
                        { path: "/Changeorgantherapycontrat", component: ChangeOrganTherapyContrat },
                        { path: "/changeorgancontrat", component: ChangeOrganContrat },
                        { path: "/changediscountcode", component: ChangeDiscountcode },
                        { path: "/changeevaluatorco", component: ChangeEvaluatorCo },
                        { path: "/changecompany", component: ChangeCompany },
                        { path: "/changethirdparty", component: ChangeThirdparty },
                        { path: "/changebodycar", component: ChangeBodyCar },
                        { path: "/changeelevator", component: ChangeElevator },
                        { path: "/changeBossToEmployee", component: ChangeResBossToEmployee },
                        { path: "/changetravel", component: ChangeTravel },
                        { path: "/changetherapy", component: ChangeTherapy },
                        { path: "/changeAccident", component: ChangeAccident },
                        { path: "/changeSmsReceiver", component: ChangeSmsReceiver },
                        { path: "/ChangeSmsReceiverEngineeringSystem", component: ChangeSmsReceiverEngineeringSystem },
                        { path: "/changecorona", component: ChangeCorona },
                        { path: "/Changepartnerrequest", component: ChangePartnerRequest },
                        { path: "/changemarketer", component: ChangeMarketer },
                        { path: "/getlocation", component: GetLocation },
                        { path: "/changeresponsdoctors", component: ChangeResponsdoctors },
                        { path: "/changeResponseSupervisingEngineer", component: ChangeResponseSupervisingEngineer },
                        { path: "/changeResponseABN", component: ChangeResABN },
                        { path: "/changeresbuildmng", component: ChangeResbuildmng },
                        { path: "/changefirehome", component: ChangeFireHome },
                        { path: "/changefirewarehouse", component: ChangeFireWarehouse },
                        { path: "/changepet", component: ChangePet },
                        { path: "/changeinvestment", component: ChangeInvestment },
                        { path: "/changefireindustrial", component: ChangeFireIndustrial },
                        { path: "/changefirehouse", component: ChangeFireHouse },
                        { path: "/changefireproperty", component: ChangeFireProperty },
                        { path: "/changefireemployeehouse", component: ChangeFireEmployeehouse },
                        { path: "/changefireownership", component: ChangeFireOwnership },
                        { path: "/changefireNonindustrial", component: ChangeFireNonIndustrial },
                        { path: "/changebuildingquality", component: ChangeBuildingQuality },
                        { path: "/changecar", component: ChangeCar },
                        { path: "/changerequiredimgdmg", component: ChangeRequiredimgdmg },
                        { path: "/Changerequestquestion", component: ChangeRequestQuestion },
                        { path: "/changesmsmanage", component: ChangeSmsManage },
                        { path: "/changerequiredimgins", component: ChangeRequiredimgins },
                        { path: "/changeparamstep", component: ChangeParamstep },
                        { path: "/Changefielddamagefile", component: ChangeFieldDamagefile },
                        { path: "/changefieldinsurance", component: ChangeFieldInsurance },
                        { path: "/changefieldinsurancegroup", component: ChangeFieldinsuranceGroup },
                        { path: "/changepermision", component: ChangePermision },
                        { path: "/changeexpert", component: ChangeExpert },
                        { path: "/changeagent", component: ChangeAgent },
                        { path: "/changeorgan", component: ChangeOrgan },
                        { path: "/changekindsendrequest", component: ChangeKindsendrequest },
                        { path: "/changekindsenddamagefile", component: ChangeKindsenddamagefile },
                        { path: "/forgetpass", component: ForgetPass },
                        { path: "/editprofile", component: EditProfile },
                        { path: "/users", component: Users },
                        { path: "/", component: Home },
                        { path: "/IssuanceMarketersPanel", component: IssuanceMarketersPanel },
                  ],
            };
            let allowedRoutes = [];
            roles.forEach(role => {
                  if (routesConfig[role]) {
                        allowedRoutes = [...allowedRoutes, ...routesConfig[role]];
                  }
            });
// اگر هیچ رول معتبری نداشت، از default استفاده کن
            if (allowedRoutes.length === 0) {
                  allowedRoutes = routesConfig.default;
            }
            if (!allowedRoutes || allowedRoutes.length === 0) {
                  allowedRoutes = []; // یا routesConfig.default اگر داری
            }

            console.log('role_name2',role_name)
            return (
                <Router>
                      <div>
                            <Hedear />
                            <div style={{ opacity: this.opacity }}>
                                  {waitState ? (
                                      <Box
                                          bgcolor="background.paper"
                                          color="text.primary"
                                          p={2}
                                          position="absolute"
                                          top={160}
                                          left="43%"
                                          zIndex="modal"
                                      >
                                            <Grid alignContent="center" alignItems="center">
                                                  <Loader
                                                      type="ThreeDots"
                                                      color="#00BFFF"
                                                      height={100}
                                                      width={100}
                                                      timeout={0}
                                                  />
                                            </Grid>
                                      </Box>
                                  ) : null}
                                  <Switch>
                                        <Route path="/login">
                                              <Login props={this.props} />
                                        </Route>

                                        {allowedRoutes.map((r, idx) => (
                                            <Route key={idx} path={r.path}>
                                                  <r.component props={this.props} />
                                            </Route>
                                        ))}
                                  </Switch>
                            </div>
                      </div>
                </Router>
            );

      }
}

const mapStateToPropsAppContainer = (state) => {
      return {
            newProperty: state.employeeProperty.employeeProperty,
            waitState: state.waitState.waitShow,
      }
}

export default connect(mapStateToPropsAppContainer)(AppContainer)
